<div class="dialog-header">
	<div class="header-title"><span style="font-size: 145%;">Send Email</span></div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="middle-content activity-dialog">

	<form #projectActivityForm="ngForm">
		<div class="form-block">
			<div class="form-row" *ngFor="let nfemail of emails; let index = index; trackBy: trackEntityById;">
				<div class="icon-block">
					<mat-icon>format_list_bulleted</mat-icon>
				</div>
				<div class="field-block">
					<input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
						[(ngModel)]="emails[index]">
				</div>
				<div class="icon-block delete-icon" (click)="deleteEmail(index)">
					<mat-icon>delete</mat-icon>
				</div>
			</div>
		</div>
		<div class="add-btn-block">
			<button mat-button class="add-btn" (click)="addEmail()" tabindex="1" type="submit"
				[disabled]="submitLoading">
				<span>Add Email</span>
			</button>
		</div>
		<div class="save-btn-block">
			<button mat-button class="save-btn" (click)="sendEmail()" tabindex="1" type="submit"
				[disabled]="submitLoading" [ngClass]="{'disabled-button': submitLoading}">
				<span *ngIf="!submitLoading">Send</span>
				<lib-mini-progress-spinner *ngIf="submitLoading"></lib-mini-progress-spinner>
			</button>
		</div>
	</form>
</div>
